const body = document.querySelector('body');
const NO_OVERFLOW_CLASS = 'no-overflow';

export const removeOverflow = () => body.classList.add(NO_OVERFLOW_CLASS);
export const addOverflow = () => body.classList.remove(NO_OVERFLOW_CLASS);
